import React from "react";
import { Tag } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  MedicineBoxOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";

const formatDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleDateString();
};

function InfoRow({ label, value }) {
  if (value == null || value === "") return null;
  return (
    <div className="vrf-card__info-row">
      <span className="vrf-card__info-label">{label}</span>
      <span className="vrf-card__info-value">{value}</span>
    </div>
  );
}

function isMedication(record) {
  return Number(record?.category_id) === 1;
}

function CategoryTag({ record }) {
  const name = record?.category_name;
  const med = isMedication(record);
  return (
    <Tag
      color={med ? "purple" : "blue"}
      icon={med ? <MedicineBoxOutlined /> : <ExperimentOutlined />}
    >
      {name || (med ? "Medication" : "Service")}
    </Tag>
  );
}

/**
 * Tariff / costable item card for search (Services and Consumables).
 */
export function TariffItemListingCard({ record, actions, onClick }) {
  const available = record?.item_status != null ? Boolean(record.item_status) : null;
  const med = isMedication(record);

  return (
    <article
      className="vrf-card search-result-card tariff-item-card"
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="vrf-card__header card-header">
        <div className="vrf-card__heading">
          <h3 className="vrf-card__title card-title">{record?.item_name || "—"}</h3>
          <p className="vrf-card__subtitle">{record?.item_code || "No item code"}</p>
        </div>
        <div className="vrf-card__badges card-status">
          <CategoryTag record={record} />
          {available != null ? (
            <span className={available ? "status-active" : "status-inactive"}>
              {available ? <CheckOutlined /> : <CloseOutlined />}
              {available ? " Available" : " Unavailable"}
            </span>
          ) : null}
        </div>
      </div>

      <div className="vrf-card__body card-body">
        <div className="vrf-card__section card-section">
          <div className="vrf-card__section-title card-label">Item</div>
          <div className="vrf-card__info card-info">
            <InfoRow label="Category" value={record?.category_name} />
            {med ? <InfoRow label="Brand" value={record?.item_brand} /> : null}
            <InfoRow label="Code" value={record?.item_code} />
          </div>
        </div>

        {med ? (
          <div className="vrf-card__section card-section">
            <div className="vrf-card__section-title card-label">Medication</div>
            <div className="vrf-card__info card-info">
              <InfoRow label="Dosage" value={record?.item_dosage} />
              <InfoRow label="Strength" value={record?.item_strength} />
              <InfoRow label="Presentation" value={record?.item_presentation} />
            </div>
          </div>
        ) : null}

        <div className="vrf-card__section card-section">
          <div className="vrf-card__section-title card-label">Registry</div>
          <div className="vrf-card__info card-info">
            <InfoRow label="Added" value={formatDate(record?.item_date)} />
            <InfoRow label="Item ID" value={record?.id != null ? String(record.id) : null} />
          </div>
        </div>
      </div>

      {actions ? (
        <div className="vrf-card__actions card-actions" onClick={(e) => e.stopPropagation()}>
          {actions}
        </div>
      ) : null}
    </article>
  );
}
